export enum MatchTeamOutcomePositionEnum {
  Winner = 1,
  Loser = -1,
  FirstPosition = 1,
  SecondPosition = 2,
}
